import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import LanguageHelper from "../../../helpers/LanguageHelper";
import FetchData from "./FetchData";
import GetOptions from "./GetOptions";
import { List, ListItem, ListItemText } from "@material-ui/core";
import CustomSnackbar from "../../../components/Snackbar/Snackbar";
import TableBackdrop from "../../../components/Table/TableBackdrop";
import Table from "../../../components/Table/Table";

const useStyles = makeStyles(() => ({
  details: {
    padding: 10,
    fontSize: 30,
    textAlign: "center",
    color: "white",
    backgroundColor: "#2D3446",
  },
  root: {
    maxHeight: 300,
    overflow: "auto",
  },
  addButton: {
    marginLeft: "12px",
  },
  editButton: {
    marginLeft: "12px",
  },
  list: {
    height: 100,
    overflow: "auto",
  },
}));

export default function UserTable() {
  const language = LanguageHelper.getLanguage();
  const tableRef = React.useRef();
  const classes = useStyles();

  const [numOfEntries, setNumOfEntries] = React.useState(0);
  const [columns, setColumns] = React.useState([]);
  const [snackbar, setSnackbar] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [severity, setSeverity] = React.useState("info");
  const [backdropLoading, setBackdropLoading] = React.useState(true);

  const init = useCallback(async () => {
    const options = await GetOptions();
    setColumns([
      { title: "No", field: "id", editable: "never", cellStyle: { minWidth: 40, maxWidth: 50 },},
      { title: "Kullanıcı Adı", field: "fullName", cellStyle: { minWidth: 300, maxWidth: 300 },},
      { title: "Email Adresi", field: "email" },
      {
        title: "Rol",
        field: "roles",
        render: (rowData) => (
          <>
            <List className={classes.list}>
              {rowData?.roles.map((data, index) => (
                <ListItem key={index}>
                  <ListItemText secondary={options.roles[`${data}`]} />
                </ListItem>
              ))}
            </List>
          </>
        ),
      },
      {
        title: "Yetkiler",
        field: "permissions",
        cellStyle: { minWidth: 500, maxWidth: 600 },
        render: (rowData) => (
            <>
              <List className={classes.list}>
                {rowData?.permissions.map((data, index) => (
                    <ListItem key={index}>
                      <ListItemText secondary={options.permissions[`${data}`]} />
                    </ListItem>
                ))}
              </List>
            </>
        ),
      },
      {
        title: "Aktiflik",
        field: "isActive",
        lookup: options.active,
        emptyValue: "Aktif Değil",
      }
    ]);
    setBackdropLoading(false);
  }, [classes]);
  React.useEffect(() => {
    init();
  }, [init]);

  return (
    <>
      <TableBackdrop backdropLoading={backdropLoading} />
      <CustomSnackbar
        snackbar={snackbar}
        setSnackbar={setSnackbar}
        snackbarMessage={snackbarMessage}
        severity={severity}
      />
      <Table
        noRowActions
        tableName={language.sidebar.users}
        authName="usersTable"
        columns={columns}
        tableRef={tableRef}
        setSnackbar={setSnackbar}
        setSnackbarMessage={setSnackbarMessage}
        setSeverity={setSeverity}
        fetchData={FetchData}
        numOfEntries={numOfEntries}
        setNumOfEntries={setNumOfEntries}
        isDeletable={false}
        isEditHidden={true}
        isTransferable={false}
        rowStyle={(rowData) => ({
          backgroundColor: !rowData.isActive && "#804f4f",
        })}
        detailsWindow={(rowData) => window.open("/user/" + rowData.id)}
        disabled={(rowData) => !rowData.isActive}
      />
    </>
  );
}
